export enum AUTH_LAYOUT_VARIANT {
  SIGN_IN = 'signIn',
  SIGN_UP = 'signUp',
  ONBOARDING = 'onboarding',
}
